$(document).ready(function() {
    // ✅ Safe AOS init
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 1500,
            once: true,
        });

        $(window).on('scroll', function() {
            AOS.refresh();
        });
    }

    // ✅ Smooth Scroll
    if (typeof SmoothScroll !== 'undefined') {
        SmoothScroll({ 
            stepSize: 80,
            animationTime: 500
        });
    }
    
    $(document).on('click', '.collaps-title', function() {
        $(this).parent().toggleClass('act');

    });

    // Back to top
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('#back-to-top').show();
        } else {
            $('#back-to-top').hide();
        }
    });
    
    // scroll body to 0px on click
    $('#back-to-top').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });


});

